<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory/stock/list')">Stocks</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Nueva Entrada en Almacén</a>
    </div>

    <h1 class="ui header">
      <i class="dolly icon"></i>
      <div class="content">Nueva Entrada en Almacén</div>
    </h1>

    <div v-if="!storesOptions || !stocksOptions || !columnsOptions" class="ui active centered inline loader"></div>
    <div v-else class="ui stackable">
      <div class="row">
        <h4 class="ui dividing header">Seleccionar Almacén</h4>
        <form class="ui form">
          <div class="two fields">
            <div v-if="(role === 'master' || role === 'admin')" class="field" id="idStore">
              <sui-dropdown fluid search selection :options="storesOptions" id="idComboStore" v-model="selectedStore"
                placeholder="Almacén" />
            </div>
            <div v-if="(role === 'master' || role === 'admin')" class="field">
            </div>
          </div>

          <h4 class="ui dividing header">Seleccionar Stock</h4>
          <div class="two fields">
            <div v-if="(role === 'master' || role === 'admin')" class="field">
              <sui-dropdown fluid search selection :options="stocksOptions" v-model="add_product"
                placeholder="Repuestos" />
            </div>
            <div v-if="(role === 'master' || role === 'admin')" class="field">
              <sui-dropdown fluid search selection :options="columnsOptions" v-model="add_product"
                placeholder="Columnas" />
            </div>
          </div>
          <div v-if="receiveStocks.length > 0" class="field" style="height: 40px ">
            <button class="ui button mini right floated" type="button" v-on:click="deleteOption('')">
              <i class="large trash alternate outline icon"></i>
              Vaciar tabla
            </button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="receiveStocks.length > 0" class="ui stackable one column divided">
      <div class="row">
        <form class="ui form">
          <table class="ui center aligned stackable table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Fabricante</th>
                <th>ID</th>
                <th>ID Fabricante</th>
                <th>Cantidad</th>
                <th>Observaciones</th>
                <th>Fecha Recepción</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="val in receiveStocks" v-bind:key="val.id">
                <td>{{ val.stock_name }}</td>
                <td>
                  <sui-dropdown fluid search selection :options="providerOptions" v-model='val.purchase_provider_id'
                    placeholder="Proveedores" />
                </td>
                <td>
                  {{ val.product_identifier }}
                </td>
                <td>
                  <div class="ui icon input fluid">
                    <input type="text" :id="'productid_' + val.id" v-model='val.product_identifier_prov'
                      placeholder="ID Fabricante">
                  </div>

                </td>
                <td v-if="!val.desglose">
                  <div id="idQuantity">
                    <i class="large minus circle icon" v-on:click="accion(val.id, 'menos')"></i>
                    <input class="inputQuantityNum" type="number" min="0" v-on:keyup="accion(val.id, 'inputNumber')"
                      v-model="val.quantity" :id="'id_' + val.id"
                      oninput="this.value = (this.value.replace(/[^0-9]/g, 0).replace('/(\..*?)\..*/g', 0)) ? this.value : 0;" />
                    <i class="large plus circle icon" v-on:click="accion(val.id, 'mas')"></i>
                  </div>
                </td>
                <td v-else>
                  {{ val.quantity }}
                </td>
                <td><textarea rows='2' maxlength='420' v-model='val.observations'></textarea></td>
                <td>
                  <input type="date" v-model="val.receive_date" placeholder="Fecha recepcion*" id="idReceiveDate">
                </td>
                <td>
                  <i class="large trash alternate outline icon" v-on:click="deleteOption(val.id)"></i>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="field" id="idBtns">
            <button id="idRecepcionar" class="ui button fluid" type="button"
              v-on:click="receiveStockConfirm">Recepcionar</button>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi'
import { error } from 'jquery';

export default {
  name: 'stockReceive',
  data() {
    return {
      role: null,
      selectedStore: null,
      add_product: null,
      receiveStocks: [],
      storesOptions: [],
      stocksOptions: [],
      columnsOptions: [],
      providerOptions: []
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role;
    if (this.role === 'master' || this.role === 'admin') {
      this.getStocks()
      this.getDataFilters()
    } else {
      this.$router.replace('/inventory')
    }
  },
  watch: {
    'add_product': function (new_pro) {
      if (new_pro != null) {
        this.addStock()
      }
    },
  },
  methods: {
    getID() {
      if (this.receiveStocks.length === 0) return 1;
      return this.receiveStocks[this.receiveStocks.length - 1].id + 1;
    },
    async getHapiickIdentifier(new_stock) {
      await hapiickApi().post('/v1/stocks/get-identifier', {
        admin_id: JSON.parse(localStorage.admin).id,
        stock_type: new_stock.stock_type
      })
        .then(request => {
          if (request.data.status === 'OK') {
            const fActual = this.fechaActual()
            const contador = this.getID()
            this.receiveStocks.push({
              id: contador,
              stock_type: new_stock.stock_type,
              stock_id: new_stock.value,
              stock_name: new_stock.text,
              product_identifier: request.data.data.identifier,
              product_identifier_prov: '',
              receive_date: fActual,
              desglose: new_stock.desglose,
              quantity: 1,
              purchase_provider_id: null
            })
            this.add_product = null
          } else {
            this.$swal({
              type: 'error',
              title: 'Error',
              text: "No se ha podido obtener el ID, intentalo de nuevo"
            })
          }
        })
        .catch((request) => {
          this.$swal({
            type: 'error',
            title: 'Error',
            text: "No se ha podido obtener el ID, intentalo de nuevo"
          })
        })
    },
    addStock() {
      // const new_stock = this.columnsOptions.find((e) => e.value == this.add.columnas) || this.stocksOptions.find((e) => e.value == this.add.repuestos)
      const new_stock = this.columnsOptions.find((e) => e.value == this.add_product) || this.stocksOptions.find((e) => e.value == this.add_product)
      // const stock_exist = this.receiveStocks.find((e) => (e.stock_id == new_stock.value && new_stock.desglose !== true))

      // if (!stock_exist) {
      this.getHapiickIdentifier(new_stock)
      // }

      this.add_product = null
    },
    fechaActual() {
      const now = new Date();
      return now.toISOString().split('T')[0];
    },
    validateData() {
      if (!this.selectedStore) {
        this.$swal.fire({
          type: 'warning',
          title: 'Revisa los datos',
          text: 'Selecciona el almacén donde quieres recepcionar el stock',
        })
        return false
      }

      if (this.receiveStocks.find(a => a.desglose && !a.product_identifier)) {
        this.$swal.fire({
          type: 'warning',
          title: 'Revisa los datos',
          text: 'Hay elementos que necesitan un ID',
        })
        return false
      }

      if (this.receiveStocks.find(a => !a.receive_date)) {
        this.$swal.fire({
          type: 'warning',
          title: 'Revisa los datos',
          text: 'La fecha de recepción no puede ser vacía',
        })
        return false
      }

      const duplicates = this.validateUniqueProductIdentifierProv()
      if (duplicates.length > 0) {
        const duplicates_str = duplicates.join(', ')
        this.$swal({
          type: 'warning',
          title: 'Revisa los datos',
          text: 'Se está intentado recepcionar productos con el mismo ID de proveedor:  ' + duplicates_str + '. Este valor tiene que ser único.'
        });
        return false;
      }

      return true
    },
    validateUniqueProductIdentifierProv() {
      const identifiers = this.receiveStocks.map(item => item.product_identifier_prov);
      const duplicates = identifiers.filter((item, index) => identifiers.indexOf(item) !== index && item !== "");

      return duplicates
    },

    receiveStockConfirm() {
      if (this.validateData()) {
        this.$swal.fire({
          type: 'question',
          title: 'Confirmar recepción',
          text: 'Se va a realizar la recepción del stock seleccionado. Por favor, confirma la operación',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.receiveStock()
          }
        })
      }
    },

    receiveStock() {
      let x = document.getElementById("idRecepcionar");
      x.classList.add("loading");
      x.disabled = true;

      this.receiveStocks = this.receiveStocks.map((a) => {
        a.store_id = this.selectedStore
        return a
      })

      hapiickApi().post('/v1/stocks/receive-without-order', {
        admin_id: JSON.parse(localStorage.admin).id,
        receiveStock: this.receiveStocks
      })
        .then(request => {
          if (request.data.status === 'OK') {
            this.$swal.fire({
              type: 'success',
              title: 'Stock recepcionado',
              text: 'El stock ahora está en el almacén',
              timer: 2500
            })
            this.initializeComponent()

          } else if (request.data.message.duplicated_key) {
            let msg = "El ID de proveedor '" + request.data.message.duplicated_key + "' ya está asignado a otra columna en el sistema"
            this.$swal({
              type: 'error',
              title: 'No se ha podido recepcionar el stock',
              text: msg
            })

            let item = this.receiveStocks.find((e) => e.product_identifier_prov == request.data.message.duplicated_key)

            let borderError = "border: 1px solid red !important"
            document.getElementById("productid_" + item['id']).style = borderError
          } else {
            this.$swal({
              type: 'error',
              title: 'Error',
              text: "No se ha podido recepcionar el stock"
            })
          }

          x.classList.remove("loading");
          x.disabled = false;
        })
        .catch((request) => {
          this.$swal({
            type: 'error',
            title: 'Error',
            text: "Ha ocurrido un error al recepcionar el stock"
          })
          x.classList.remove("loading");
          x.disabled = false;
        })
    },
    async getStocks() {
      await hapiickApi().post('/v1/stocks', {
        admin_id: JSON.parse(localStorage.admin).id,
      })
        .then(request => {
          const stock = JSON.parse(JSON.stringify(request.data.stocks));
          this.fillStocksOptions(stock)
        })
        .catch((req) => {
          console.log('error getting stocks')
        })
    },
    async getDataFilters() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        Store: true,
        PurchaseProvider: true,
      })
        .then(request => {
          let stores = [...request.data.data.stores];
          let purchase_provider = [...request.data.data.purchase_provider];

          this.fillStoresOptions(stores)
          this.fillPurchaseProviderOptions(purchase_provider)
        })
        .catch(() => console.log('error getting combo informations'))
    },
    fillStocksOptions(stocks) {
      for (let i = 0; i < stocks.length; i++) {
        let stock = {}
        stock['id'] = stocks[i].id,
          stock['key'] = stocks[i].id,
          stock['value'] = stocks[i].id,
          stock['text'] = stocks[i].name
        stock['stock_type'] = stocks[i].stock_type
        stock['desglose'] = stocks[i].desglose

        if (stocks[i].stock_type === 'R') {
          this.stocksOptions.push(stock)
        } else {
          this.columnsOptions.push(stock)
        }
      }

      if (this.stocksOptions.length === 0) {
        this.stocksOptions.push({
          'text': 'No hay repuestos',
        })
      }
      if (this.columnsOptions.length === 0) {
        this.columnsOptions.push({
          'text': 'No hay columnas',
        })
      }
    },
    fillStoresOptions(stores) {
      if (stores.length === 0) {
        this.storesOptions.push({
          'text': 'No hay almacenes',
        })
        return
      }

      for (let i = 0; i < stores.length; i++) {
        this.storesOptions.push({
          key: stores[i].Store.key,
          text: stores[i].Store.name,
          value: stores[i].Store.id,
        })
      }
    },
    fillPurchaseProviderOptions(providers) {
      if (providers.length === 0) {
        this.providerOptions.push({
          'text': 'No hay proveedores',
        })
        return
      }

      for (let i = 0; i < providers.length; i++) {
        this.providerOptions.push({
          text: providers[i].Provider.name,
          value: providers[i].Provider.id,
        })
      }
    },
    accion(id, accion) {
      let inputQuantity = document.getElementById('id_' + id)

      if (accion === 'mas') {
        inputQuantity.value++
      } else if (accion === 'menos' && inputQuantity.value > 1) {
        inputQuantity.value--
      }

      this.receiveStocks.map((a) => {
        if (a.id == id) {
          a.quantity = inputQuantity.value
        }
      })
    },
    deleteOption(id) {
      if (id == '') {
        this.cleanTable()
      } else {
        this.receiveStocks = this.receiveStocks.filter(aux => aux.id != id);
      }
    },
    initializeComponent() {
      this.receiveStocks = []
      this.selectedStore = null
      // this.add.repuestos = null
      // this.add.columnas = null
      this.add_product = null
    },

    cleanTable() {
      this.receiveStocks = []
    },

    goTo(where) {
      this.$router.push(where)
    }
  },
}
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

#idBtns {
  display: flex;
  justify-content: center;
}

#idRecepcionar {
  background-color: black !important;
  color: white;
  width: 35%;
}

#idQuantity {
  align-items: center !important;
  display: inline-flex !important;
  vertical-align: middle !important;
}

.inputQuantityNum {
  width: 50px !important;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Inventory/stockReceive.vue